import React from 'react'
import { SpeakerBadge } from './speaker-badge'
import { AudioStatusIndicator } from './audio-status-indicator'
import { MoodSelector } from './mood-selector'
import type { PodcastStatusValue } from '../../../../types/enums'

export const LineHeader: React.FC<{
  index?: number
  displayHost: string
  hostColorClass?: string
  hasAudio: boolean
  isProcessing: boolean
  status?: PodcastStatusValue
  onToggleHost?: () => void
  nextHostLabel?: string
  emotion?: string
  onEmotionChange?: (emotion: string) => void
}> = ({
  index,
  displayHost,
  hostColorClass,
  hasAudio,
  isProcessing,
  status,
  onToggleHost,
  nextHostLabel,
  emotion,
  onEmotionChange
}) => (
    <div className="flex items-center justify-between gap-3 mb-3">
      <div className="flex items-center gap-2 min-w-0">
        {typeof index === 'number' && (
          <span className="text-xs text-foreground/50" title={`Line #${index + 1}`}>#{index + 1}</span>
        )}
        <SpeakerBadge host={displayHost} colorClass={hostColorClass} onToggleHost={onToggleHost} disabled={isProcessing} nextHostLabel={nextHostLabel} />
        <MoodSelector emotion={emotion} onChange={onEmotionChange || (() => { })} disabled={isProcessing} />
        <AudioStatusIndicator hasAudio={hasAudio} isProcessing={isProcessing} status={status} />
      </div>
      {/* Per-line generate/regenerate/play buttons removed */}
    </div>
  )
